/** "How points work" — the fan's page, opened from the game screen.
 *
 *  Public, by table card, like every other fan screen. It only reads: a fan
 *  cannot change anything here.
 */
import { useCallback, useEffect, useState } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { ArrowLeft, Loader2 } from 'lucide-react';
import { PatronPageView } from '../../components/patron/PatronPageView';

const API = `${(typeof window !== 'undefined' ? window.location.origin : '')}/api/patron`;
const DEVICE_KEY = 'patron_device_id';

export default function HowPointsWork() {
    const { cardId } = useParams();
    const [params] = useSearchParams();
    const navigate = useNavigate();
    const [page, setPage] = useState(null);
    const [failed, setFailed] = useState(false);
    const lang = (params.get('lang') || localStorage.getItem('i18nextLng') || 'en')
        .startsWith('fr') ? 'fr' : 'en';

    const load = useCallback(async () => {
        try {
            const device = localStorage.getItem(DEVICE_KEY) || '';
            const res = await fetch(
                `${API}/public/${cardId}/page/how-it-works?lang=${lang}`
                + `&device_id=${encodeURIComponent(device)}`);
            if (!res.ok) throw new Error('page');
            setPage(await res.json());
        } catch (_e) { setFailed(true); }
    }, [cardId, lang]);

    useEffect(() => { load(); }, [load]);

    const back = () => navigate(`/goal/${cardId}`);

    if (failed) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-slate-950 text-white px-6 text-center"
                 data-testid="patron-page-failed">
                <p className="text-sm opacity-80">This page is not available right now.</p>
            </div>
        );
    }

    if (!page) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-slate-950 text-white"
                 data-testid="patron-page-loading">
                <Loader2 className="animate-spin" size={22} />
            </div>
        );
    }

    return (
        <div className="relative" data-testid="patron-page-screen">
            <PatronPageView page={page} onAction={back} />
            <button type="button" onClick={back} data-testid="patron-page-back"
                    className="fixed bottom-4 left-1/2 -translate-x-1/2 z-30 min-h-[44px]
                               inline-flex items-center gap-2 rounded-xl border px-5 text-sm font-bold"
                    style={{ backgroundColor: 'rgba(0,0,0,0.72)', color: '#fff',
                             borderColor: 'rgba(255,255,255,0.25)' }}>
                <ArrowLeft size={15} />{page.lang === 'fr' ? 'Retour au jeu' : 'Back to the game'}
            </button>
        </div>
    );
}
